import './BakersView.css';
import { useState, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import CakeOrderDashboard from './CakeOrderDashboard';
import BreadOrderDashboard from './BreadOrderDashboard/BreadOrderDashboard';
import breadService from '../../services/breadorders.service';
import cakeService from '../../services/cakeorders.service';
import NewBreadOrderNotification from './NewBreadOrderNotification/NewBreadOrderNotification';
import NewCakeOrderNotification from './NewCakeOrderNotification/NewCakeOrderNotification';



export default function BakersView() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState('cakes');
    const [breadOrders, setBreadOrders] = useState([]);
    const [cakeOrders, setCakeOrders] = useState([]);
    const reloadToken = searchParams.get('reload');

    const [showBreadModal, setShowBreadModal] = useState(false);
    const [newBreadOrders, setNewBreadOrders] = useState(null);
    const previousBreadOrderIds = useRef(new Set());

    const [showCakeModal, setShowCakeModal] = useState(false);
    const [newCakeOrders, setNewCakeOrders] = useState(null);
    const previousCakeOrderIds = useRef(new Set());

    useEffect(() => {
        const initialTab = new URLSearchParams(window.location.search).get('tab');
        if (initialTab === 'cakes' || initialTab === 'breads') {
            setActiveTab(initialTab);
        }
    }, []);

    useEffect(() => {
        let cleanup = () => {};
        if (activeTab === 'breads') {
            breadService.fetchBreadsWithListeners(false, (orders) => {
                detectNewBreadOrders(orders);
                setBreadOrders(orders);
            });
            cleanup = () => {
                if (typeof breadService.unsubscribe === 'function') {
                    breadService.unsubscribe();
                }
            };
        } else if (activeTab === 'cakes') {
            cakeService.fetchCakesWithListener(false, (orders) => {
                detectNewCakeOrders(orders);
                setCakeOrders(orders);
            });
            cleanup = () => {
                cakeService.stopListening();
            };
        }
        return () => cleanup();
    }, [activeTab, reloadToken]);

    function handleTabChange(tab) {
        setActiveTab(tab);
        setSearchParams({ tab });
    }

    function detectNewBreadOrders(orders) {
        const today = new Date().toISOString().split('T')[0];
        const newOrders = []
        orders.forEach(order => {
            if (!previousBreadOrderIds.current.has(order.id) && order.date === today && order.status === 'pending') {
                console.log('New bread order detected:', order);
                previousBreadOrderIds.current.add(order.id);
                newOrders.push(order);
            }
        });
        if (newOrders.length > 0) {
            setNewBreadOrders(newOrders);
            setShowBreadModal(true);
        }
    }

    function detectNewCakeOrders(orders) {
        const today = new Date().toISOString().split('T')[0];
        const newOrders = []
        orders.forEach(order => {
            if (!previousCakeOrderIds.current.has(order.id) && order.date === today && !order.ready) {
                console.log('New cake order detected:', order);
                previousCakeOrderIds.current.add(order.id);
                newOrders.push(order);
            }
        });
        if (newOrders.length > 0) {
            setNewCakeOrders(newOrders);
            setShowCakeModal(true);
        }
    }


    return (
        <div className='basicContainer bakers-view'>
            <div className='bakers-view-nav'>
                <button className='bakers-view-nav-button' onClick={() => handleTabChange('cakes')}>🧁 Pasteles </button>
                <button className='bakers-view-nav-button' onClick={() => handleTabChange('breads')}>🍞 Panes</button>
            </div>
                {activeTab === 'cakes' && (
                    <div className='cakes-content'>
                       <CakeOrderDashboard cakeOrders={cakeOrders} />
                    </div>
                )}
                {activeTab === 'breads' && (
                    <div className='breads-content'>
                       <BreadOrderDashboard breadOrders={breadOrders}/>
                    </div>
                )}

            {showBreadModal && (
                <NewBreadOrderNotification newOrders={newBreadOrders} setShowModal={setShowBreadModal} />
            )}

            {showCakeModal && (
                <NewCakeOrderNotification newOrders={newCakeOrders} setShowModal={setShowCakeModal} />
            )}

        </div>
    );
}